function validar_email(email) {
  let expresion = /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/;
  if (!expresion.test(email)) {
    return false;
  } else {
    return true;
  }
}
export default validar_email;
